import React from 'react';
import '../../../shared/components/layout/StoreDashboardLayout.css';
import StoreIntelligencePanel from '../../analytics/components/store-intelligence/StoreIntelligencePanel';
import useStoreIntelligence from '../../analytics/hooks/useStoreIntelligence';
import './StoreHealth.css';

const StoreHealth = ({ request, storeToken, onToast }) => {
  const storeIntelligence = useStoreIntelligence({
    request,
    storeToken,
    refreshSignal: 1,
    onToast
  });

  return (
    <div className="store-health-shell">
      <section className="dashboard-tab-hero store-health-hero">
        <div className="dashboard-tab-hero-copy">
          <p className="dashboard-tab-hero-eyebrow">AI health summary</p>
          <h3 className="dashboard-tab-hero-title">Store Health</h3>
          <p className="dashboard-tab-hero-subtitle">
            A weekly read on revenue signals, repeat behavior, operational pressure, and trust.
          </p>
          <div className="dashboard-tab-hero-tags">
            <span className="dashboard-tab-hero-tag">Read-only strategy</span>
            <span className="dashboard-tab-hero-tag">Weekly summary</span>
          </div>
        </div>
      </section>

      <StoreIntelligencePanel intelligence={storeIntelligence} />
    </div>
  );
};

export default StoreHealth;
